<template>
  <button
    class="flex size-6 items-center justify-center rounded-md text-bittersweet-600 hover:bg-bittersweet-600 hover:text-white"
    @click.stop="$emit('delete')"
  >
    <XIcon class="size-4" />
  </button>
</template>
<script setup lang="ts">
import { XIcon } from 'lucide-vue-next';

defineEmits<{
  (e: 'delete'): void;
}>();
</script>
